import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { ApolloClient, ApolloProvider, InMemoryCache, createHttpLink } from "@apollo/client";
import { setContext } from '@apollo/client/link/context';
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../src/style/css/feather.css";
import "../src/index.scss";
import store from "./core/data/redux/store";
import { Provider } from "react-redux";
import "../src/style/icon/boxicons/boxicons/css/boxicons.min.css";
import "../src/style/icon/weather/weathericons.css";
import "../src/style/icon/typicons/typicons.css";
import "../src/style/icon/fontawesome/css/fontawesome.min.css";
import "../src/style/icon/fontawesome/css/all.min.css";
import "../src/style/icon/ionic/ionicons.css";
import "../src/style/icon/tabler-icons/webfont/tabler-icons.css";
import ALLRoutes from "./feature-module/router/router";
import "../node_modules/bootstrap/dist/js/bootstrap.bundle.min.js";

// Create an HTTP link
const httpLink = createHttpLink({
  uri: 'https://api-dev.eneotransportation.com', // Replace with your GraphQL endpoint
});

// Middleware to set the token in the request headers
const authLink = setContext((_, { headers }) => {
  const token = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJsb2dpbklkIjoxMTcyLCJ1c2VybmFtZSI6ImVuZW90cmFjayIsInJvbGVzIjoiQ0xJRU5UIiwiaWF0IjoxNzIyNjAyNjU1fQ.Ikn3M7TjIT0efXkg0Pt1PxMOuG744M8OpBqKhNTAHsg"; // Replace with your token retrieval logic
  const apiKey = "EKJ0BDHKQ2MGNV3S26GVFMV3ZXSN1DMK"; // Replace with your API key

  console.log('Request Headers:', {
    ...headers,
    authorization: token ? `Bearer ${token}` : '',
    // 'api-key': apiKey
  });
  return {
    headers: {
      ...headers,
      'Authorization': token ? `Bearer ${token}` : '',
      //  'api-key': apiKey
    },
  };
});

// Initialize Apollo Client
const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ApolloProvider client={client}>
        <BrowserRouter>
          <ALLRoutes />
        </BrowserRouter>
      </ApolloProvider>
    </Provider>
  </React.StrictMode>
);
